import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { FindUser } from '../../../../find-user-page/find-user';
import { UserType } from '../../../../../api/types/user/user-type';
import { UserSummaryType } from '../../../../../api/types/user/user-summary.type';

interface AddProfessorsDialogContentProps {
  visible: boolean;
  alreadySelectedProfessors: UserSummaryType[];
  onApprove: (selectedProfessors: UserSummaryType[]) => void;
  onHide: () => void;
}

const mergeUniqueById = (
  base: UserSummaryType[],
  incoming: UserSummaryType[],
): UserSummaryType[] => {
  const seen = new Set<number>();
  const merged: UserSummaryType[] = [];
  [...base, ...incoming].forEach((user) => {
    if (!seen.has(user.id)) {
      seen.add(user.id);
      merged.push(user);
    }
  });
  return merged;
};

export const AddProfessorsDialogContent: React.FC<
  AddProfessorsDialogContentProps
> = ({ visible, alreadySelectedProfessors, onApprove, onHide }) => {
  const [selectedProfessors, setSelectedProfessors] = useState<
    UserSummaryType[]
  >([]);

  useEffect(() => {
    if (visible) {
      setSelectedProfessors([]);
    }
  }, [visible]);

  const handleApprove = () => {
    const merged = mergeUniqueById(
      alreadySelectedProfessors,
      selectedProfessors,
    );
    onApprove(merged);
    onHide();
  };

  return (
    <>
      <FindUser
        role={UserType.LECTURER}
        onChange={setSelectedProfessors}
        onApprove={() => {
          //
        }}
        displayApprove={false}
      />
      <div
        style={{
          marginTop: '8px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'left',
        }}
      >
        <Button
          style={{ height: '30px' }}
          label={'ביטול'}
          outlined={true}
          onClick={onHide}
        />
        <div style={{ marginRight: '8px' }} />
        <Button
          onClick={handleApprove}
          style={{ height: '30px' }}
          label={'אישור'}
          disabled={selectedProfessors.length === 0}
        />
      </div>
    </>
  );
};
